export const WORD_CLOUD_SERIES_BASE = {
  maxFontSize: 80,
  minFontSize: 14,
  name: 'Occurrences',
  rotation: { from: 0, to: 0 },
  type: 'wordcloud',
};

export const buildWordCloudChartOptions = ({
  creditsEnabled = false,
  data,
  exportingEnabled = false,
  titleText = undefined,
  tooltipEnabled = true,
} = {}) => ({
  credits: { enabled: creditsEnabled },
  exporting: { enabled: exportingEnabled },
  series: [
    {
      ...WORD_CLOUD_SERIES_BASE,
      data,
    },
  ],
  title: { text: titleText },
  tooltip: { enabled: tooltipEnabled },
});
